/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState, useEffect} from 'react';

import {PagerModel} from "./PagerModel";
import {Pager} from "./Pager";
import {ColumnType} from "./ColumnType";
import {Big} from "big.js";

import {ExportDataTable} from "./ExportDataTable";
import {formatDate} from "../../../util/date";
import {DeleteButtonModal} from "../../../util/DeleteButtonModal";
import {NavLink} from "react-router-dom";
import {ToggleButton} from "./ToggleButton";
import ReactTooltip from "react-tooltip";

const ProgressBar: React.FC<{}> = () => {
    const [progress, setProgress] = useState(0);
    const [startTime, setStartTime] = useState(Date.now());

    const incrementProgress = () => {
        const elapsedTime = Date.now() - startTime;
        const newProgress = Math.sqrt(elapsedTime / 5);

        if (newProgress >= 100) {
            setProgress(100);
        } else {
            setProgress(newProgress);
            setTimeout(incrementProgress, 50);
        }
    };

    useEffect(() => {
        incrementProgress();
    }, []);

    const progressBarStyle = {
        heigh: "100%",
        maxHeight: "3px"
    }

    return (
        <>
        {progress < 100 && (
                    <div className="progress" style={progressBarStyle}>
                        <div className="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
        )}
        </>
    )
    
}

interface Props {
    nameResource? : string;
    pager : PagerModel;
    columns: Array<{ property : string, name : string,className? : string,  type? : ColumnType, getUrl? : (item : any) => string; getExternalUrl? : (item : any) => string; linkClass?: string }>;
    items : Array<any>;
    onPagerChange : (pager : PagerModel) => void;
    loading? :  boolean;
    onAction? : (item : any, actionId : string, index : number) =>  Promise<any> | undefined;
    actions? : Array<DataTableAction>;
    removed? : number[];
    itemsUpdating : number[];
    showIndex? : boolean;
    setMaxLimit?:number;
    autoRefreshOptions?: number[];
    onAutoRefreshChange?: (value: number | undefined ) => void;
}

/**
 * Renderer for a column value. If the renderer is set on a column
 * it will be used to render it regardless of the property name.
 */
export interface Renderer<t> {
  (property: string, name: string, item: any): t
}

export enum ActionType {
    DEFAULT, LINK, CONFIRMATION, BLOCK, CANCEL
}
export interface DataTableAction {
    id : string,
    name : string;
    className? : string;
    iconClassName? : string;
    filter? : (item : any) => boolean;
    type? : ActionType;
    getLink? : (item : any) => string;
    isBlocked? : (item : any) => boolean;
    optional? : (item : any) => boolean;
}
export interface State {
    pagerOffsetPlaceholder: string;
}

export class DataTable extends React.Component<Props,State> {
    offsetError: boolean = false;
    maxlimit =  this.props.setMaxLimit === 100 ? [10,20,50,100]  : [10,20,50,100,500,1000];
    limits : Array<number> = this.maxlimit;
    constructor(props: Props) {
        super(props);
        this.state = this.getStateFromPager(this.props.pager);
    }
    getStateFromPager(pager: PagerModel): State {
        return {pagerOffsetPlaceholder: ""+Math.floor(pager.offset/pager.limit + 1)};
    }

    getClass(column : any) {
        if(this.hasSort(column)) {
            if(this.props.pager.orderBy == column.orderBy) {
                if(this.props.pager.ascending) {
                    return "sorting_asc";
                } else {
                    return "sorting_desc";
                }
            } else {
                return "sorting";
            }
        } else {
            return "";
        }
    }

    getPropertyValue(item : any, property : string, column: any) : any {
        if (column.renderer != null) {
          return column.renderer(property, column.name, item);
        } else if (property.indexOf(".") != -1) {
            let parts = property.split(".");
            let value = item;

            for(var i = 0; i<parts.length; i++) {
                value = value[parts[i]];
            }
            return value;
        } else {
            return item[property];
        }

    }
    setOffset(offset : number) {
        let pager : PagerModel = Object.assign({}, this.props.pager);
        pager.offset = offset;
        this.props.onPagerChange(pager);
        this.setState(this.getStateFromPager(pager));
    }

    hasSort(column : any) {
        return typeof(column.orderBy) != "undefined";
    }

    onAction(item : any, id : string, index : number) : Promise<any> | undefined {
        if(this.props.onAction && this.props.itemsUpdating.indexOf(index) == -1) {
            return this.props.onAction(item,id, index);
        }
    }

    sort(column : any) {
        if(!column.orderBy) {
            return;
        }
        let ascending = false;
        if(this.props.pager.orderBy == column.orderBy) {
            ascending = !this.props.pager.ascending;
        } else {
            ascending = this.props.pager.ascending;
        }

        let pager : PagerModel = Object.assign({},this.props.pager);
        pager.orderBy = column.orderBy;
        pager.ascending = ascending;
        this.props.onPagerChange(pager);
    }

    getLimitOptions() {
        return this.limits.map( l => {
            return (
                <option key={'limit-'+l} value={""+l}>{l}</option>
            );
        });
    }

    getHeaders() {
        return this.props.columns.map( c => {
            let align : any= (c.type == ColumnType.BIG ? ({ textAlign : "right"}): ({ textAlign : ""}));
            if (this.hasSort(c)) {
                return (
                    <th key={"h-" + c.name} style={align} onClick={this.sort.bind(this, c)}  className={this.getClass(c)}>{c.name}</th>
                );
            } else {
                return (
                    <th key={"h-" + c.name} style={align}>{c.name}</th>
                );
            }
        })
    }

    getColumns(item : any) {
        return this.props.columns.map( c => {
            let cssName = c.property.replace(/\\./g, "_");
            if(c.className) {
                cssName = c.className;
            }
            if(c.type == ColumnType.BIG) {
                let val = new Big(this.getPropertyValue(item, c.property, c,));
                let container = <span className={val.lt(0) ? "negative" : "positive"}>{val.toFixed(10)}</span>;
                return <td className={cssName} key={c.property + "column"} style={{textAlign : "right"}}>{container}</td>
            } else if(c.type === ColumnType.NOTE) {
                let text:string = this.getPropertyValue(item, c.property, c);
                let tooltipId = item.id + "-" +  (Math.random() + 1).toString(36).substring(5);
                if(text && text.length > 0) {
                    console.log("note: ", c);
                    console.log("note: ", item);
                    return <td key={c.property + "column"} className={cssName} >
                        <div className="note-icon" style={{position:"relative"}}>
                            {item && item.pinnedNote && <i className="fas fa-thumbtack" style={{
                                color: "dodgerblue",
                                transform: "rotate(-45deg)",
                                position: "absolute",
                                top: "-5px",
                                left: "-5px",
                                zIndex: 2
                            }}/>}
                            <i className="far fa-comment-alt" style={{fontSize:"18px", zIndex:1, position:"absolute"}}  data-tip data-for={"noteTip_"+tooltipId}/>
                        </div>
                        <ReactTooltip id={"noteTip_"+tooltipId} place="top" effect="solid" type="info">
                            {text}
                        </ReactTooltip>
                    </td>
                } else {
                    return <td key={c.property + "column"} className={cssName} ></td>

                }
            } else if(c.type == ColumnType.DATE) {
                let timestamp: number = this.getPropertyValue(item,c.property, c) ? Number(this.getPropertyValue(item,c.property, c).toString().split(".").join("").substring(0,13)) : 0;
                return <td key={c.property + "column"} className={cssName} >{formatDate(timestamp)}</td>
            } else if(c.type == ColumnType.ENUM) {
                return <td key={c.property + "column"} className={cssName + " " + this.getPropertyValue(item,c.property, c)}>{ this.getPropertyValue(item,c.property, c)}</td>
            } else if(c.type == ColumnType.IMAGE) {
                return <td key={c.property + "column"} className={cssName} > <img alt={"list view"} src={this.getPropertyValue(item,c.property, c)} className="listViewImage" /> </td>
            } else if(c.type == ColumnType.LIST) {
                return <td key={c.property + "column"} className={cssName} > {(this.getPropertyValue(item,c.property, c) as any[]).join(", ")} </td>
            } else if(c.type === ColumnType.LINK && c.getUrl) {
                let url = c.getUrl(item);
                return (
                    <td key={c.property + "column"} className={cssName} >
                        { url && <NavLink className={c.linkClass ? c.linkClass : ""} to={c.getUrl(item)}>{this.getPropertyValue(item, c.property, c)}</NavLink> }
                        { !url && <a>{this.getPropertyValue(item, c.property, c)}</a>}
                    </td>
                );
            } else if(c.type === ColumnType.LINK && c.getExternalUrl) {
                let url = c.getExternalUrl(item);
                if(url != undefined) {
                    return (
                        <td key={c.property + "column"} className={cssName} >
                            <a className={c.linkClass ? c.linkClass : ""} target="_blank" href={url}>{this.getPropertyValue(item, c.property, c)} <i className="fa fa-external-link-alt"/> </a>
                        </td>
                    );
                } else {
                    return <td key={c.property + "column"} className={cssName} >{this.getPropertyValue(item, c.property, c)}</td>
                }
            } else {
                return <td key={c.property + "column"} className={cssName} >{this.getPropertyValue(item, c.property, c)}</td>
            }
        });
    }
    getActions(item : any, index : number) : any {
        if(!this.props.actions || this.props.actions.length==0 || this.isRemoved(index)){
            return false;
        }
        return this.props.actions.filter( a=> {
            if(a.filter && a.filter(item) === false)  {
                return false;
            } else {
                return true;
            }
        }).map( a => {

            if(a.type == ActionType.CONFIRMATION) {
                return <DeleteButtonModal iconClassName={a.iconClassName} className={a.className} key={"delete-"+a.id} onDelete={()=>this.onAction(item,a.id, index)} label={a.name}/>;
            } else if(a.getLink && a.type == ActionType.LINK) {
                return <NavLink key={"action" + a.id} className={a.className} to={a.getLink(item)}><i className={a.iconClassName}></i> {a.name}</NavLink>
            } else if(a.isBlocked && a.type == ActionType.BLOCK) {
                let disabled = a.isBlocked(item);
                if(a.id==="block" && item['blocked']===false){
                    a.name="Block";
                    a.className="btn btn-success";
                    a.iconClassName="fa fa-thumbs-down";
                }
                else if(a.id==="block" && item['blocked']===true){
                    a.name="Unblock";
                    a.className="btn btn-danger";
                    a.iconClassName="fa fa-thumbs-up";
                }
                return <ToggleButton key={a.id} onAction={()=>this.onAction(item, a.id, index)} disabled={disabled} type={ActionType.BLOCK}/>
                //return <DeleteButtonModal iconClassName={a.iconClassName} className={a.className} key={"delete-"+a.id} onDelete={()=>this.onAction(item,a.id, index)} label={a.name}/>;
            } else if(a.optional && a.type == ActionType.CANCEL) {
                let optional = a.optional(item);
                if(optional) {
                    return <DeleteButtonModal iconClassName={a.iconClassName} className={a.className} key={"delete-"+a.id} onDelete={()=>this.onAction(item,a.id, index)} label={a.name}/>;
                } else return null;
            } else {
                return (
                    <a key={"action-"+a.id} onClick={()=>this.onAction(item, a.id, index)} className={a.className}><i className={a.iconClassName}></i> {a.name}</a>
                );
            }

        });
    }
    isRemoved(index : number){
        return this.props.removed && this.props.removed.length && this.props.removed.indexOf(index) != -1;
    }
    isUpdating(index : number) {
        return  this.props.itemsUpdating && this.props.itemsUpdating.length && this.props.itemsUpdating.indexOf(index) != -1;
    }
    geActionColumn(index : number, item : any) : any {
        if(this.props.actions && this.props.actions.length > 0) {
            return (
                <td className="actions">
                    {this.getActions(item,index)}
                </td>
            );
        }
        return false;
    }
    getRowClasses(index : number) {

        if(this.isRemoved(index)) {
            return "removed";
        }
        if(this.isUpdating(index)) {
            return "updating";
        }
        return "";
    }

    getLoading(){
        const overlayStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // this provides a semi-transparent black background
            zIndex: 9999, // this ensures the overlay is on top of everything else
        };
        
        return (
        <div style={overlayStyle}>
            <div className="alert alert-info d-flex align-items-center" role="alert">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status">
                <span className="sr-only">Loading...</span>
                </div>
                Loading...
            </div>
        </div>)
    }

    getResults() {  
        return this.props.items.map((item,index) => {
            return(
                <><tr id={'tr'.concat(item.id)} key={index + "-" + item.id} className={this.getRowClasses(index)}>
                    {this.getIndexColumn(index)}
                    {this.getColumns(item)}
                    {this.geActionColumn(index, item)}
                </tr>{
                    this.getResultsSubRowByResource(item, index)
                }</>
            );
        });
    }

    getResultsSubRowByResource(item:any, index:number) {     
        if(this.props.nameResource==="AuditLogListView"){
            if(item.request==="" || item.request===null){
                return (
                    <tr id={'auditlogtr'.concat(item.id)} style={{display:'none', width:'5px'}}>
                        <td>{}</td> 
                    </tr>
                );
            }else{
                return (
                    <tr id={'auditlogtr'.concat(item.id)} style={{display:'none', width:'5px'}}>
                        <td>{item.request}</td> 
                    </tr>
                );
            }
        }
    }

    getIndexHeader() : any {
        if(this.props.showIndex) {
            return <th>Pos</th>
        }
        return false;
    }
    getActionHeader() : any {
        if(this.props.actions && this.props.actions.length > 0) {
            return <th className="actions">Actions</th>;
        }
        return false;
    }

    limitChange(e : React.FormEvent) {
        let value : string = (e.target as any).value;
        console.log(value);
        let pager : PagerModel = Object.assign({},this.props.pager ? this.props.pager : new PagerModel());
        pager.limit = parseInt(value);
        pager.offset = 0;
        this.props.onPagerChange(pager);
        this.setState(this.getStateFromPager(pager));
    }

    offsetChange(e : React.FormEvent) {
        let value : string = (e.target as any).value;
        if (!isNaN(+value) && value.length > 0) {
            this.props.pager!.offset = parseInt(value);
            this.offsetError = false;
            this.setState({pagerOffsetPlaceholder: ""+parseInt(value)});
        } else {
            this.offsetError = true;
            this.setState({pagerOffsetPlaceholder: value});
        }
    }

    updateOffsetIfEnter(e : any) {
        if (e.keyCode == 13 && e.shiftKey == false && this.offsetError == false) {
            this.setOffset((parseInt(this.state.pagerOffsetPlaceholder)-1)*this.props.pager!.limit);
        }
    }

    handleRefreshChange(event: React.FormEvent){
        event.preventDefault()
        const value = event.target.value;
        this.setState({autoRefreshInterval: value });
        if(this.props.onAutoRefreshChange) this.props.onAutoRefreshChange(value=== "never"? undefined : Number(value));
    }

    renderAutoRefresh(){
        return (                    
            <label>
                &nbsp;&nbsp;
                Auto Refresh 
                &nbsp;
                <select className="form-control input-sm" value={this.state.autoRefreshInterval || undefined } onChange={(e: any) => this.handleRefreshChange(e)}>
                    <option value="never">Never</option>
                    {this.props.autoRefreshOptions.map((option: number)=>(
                            <option key={option} value={option}>{option} seconds</option>
                    ))}
                </select>
            </label>
        )
    }

    render() {
        return (
            <div className="dataTables_wrapper dt-bootstrap" style={{position: 'relative'}}>
                <div className={"row"}>
                    <div className="col-md-10">
                        <div className="form form-inline" >
                            <label>
                                Go to Page (press enter)
                                <input className={"form-control" + (this.offsetError ? " error" : "")} style={{width: "50px", margin: "5px"}} value={""+this.state.pagerOffsetPlaceholder} onChange={this.offsetChange.bind(this)} onKeyDown={this.updateOffsetIfEnter.bind(this)}/>
                            </label>
                            <label>
                                Show
                                <select className="form-control input-sm" value={""+this.props.pager.limit} onChange={this.limitChange.bind(this)}>
                                    { this.getLimitOptions() }
                                </select>
                            </label>
                            <ExportDataTable items={this.props.items} columns={this.props.columns} /> 
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form form-inline" >
                            {this.props.autoRefreshOptions && this.props.autoRefreshOptions.length && (
                                this.renderAutoRefresh()
                            )}
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className="table-responsive">
                                <table className="table table-striped mb-0 dt-responsive dataTable no-footer dtr-inline" style={{"position": "relative"}}>
                                    <thead>
                                        <tr role="row">
                                            { this.getIndexHeader() }
                                            { this.getHeaders() }
                                            { this.getActionHeader() }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr id="-1">
                                            <td style={{padding:"0px", height:"3px"}} colSpan={(this.props.columns ? this.props.columns.length : 0) + (this.props.actions ? this.props.actions.length : 0)}>
                                                {this.props.loading && (<ProgressBar/>)}
                                            </td>
                                        </tr>
                                        { this.getResults() }                 
                                    </tbody>
                                </table>
                                { this.props.loading && 
                                    this.props.autoRefreshOptions && 
                                    this.props.autoRefreshOptions.length &&
                                    this.state.autoRefreshInterval &&
                                    this.state.autoRefreshInterval !== "never" &&
                                    this.getLoading() 
                                }
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-sm-12 col-md-12 col-lg-1 col-12"}>
                        <div className="dataTables_info" >
                            { this.getNrOfResults() }
                        </div>
                    </div>
                    <div className={"col-sm-12 col-md-12 col-lg-12 col-12"}>
                        <Pager onOffsetUpdate={this.setOffset.bind(this)} model={this.props.pager}/>
                    </div>
                </div>
            </div>
        );
    }

    getIndexColumn(index:number) : any {
        if(this.props.showIndex) {
            return <td>{ index + 1 + (this.props.pager.offset ? this.props.pager.offset : 0) }</td>
        }
        return false;
    }

    private getNrOfResults() {
        if (this.props.pager.nrOfResults < 0) { // unspecified nbr of results - implemented for some very large tables
            return <span/>;
        }
        return <span>Total nr of Results: {this.props.pager.nrOfResults}</span>;
    }
}
